import { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

export function useBids(itemId) {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!itemId) {
      setBids([]); // No item, no bids
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setBids([]); // Reset bids while loading for new item

    console.log(`Fetching bids for item ID: ${itemId}`);
    const q = query(
      collection(db, "bids"),
      where("itemId", "==", itemId),
      orderBy("amount", "desc"),
      orderBy("placedAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        console.log(`Received ${snapshot.docs.length} bids`);
        const bidsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBids(bidsData);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bids:", err);
        setError(err);
        setLoading(false);
        setBids([]);
      }
    );

    // Cleanup subscription on unmount or itemId change
    return () => {
      console.log("Unsubscribing from bids listener");
      unsubscribe();
    };
  }, [itemId]); // Re-run effect if itemId changes

  return { bids, loading, error };
}
